import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { dateValidator } from 'src/app/validators/date.validator';

@Component({
  selector: 'app-marital-form',
  templateUrl: './marital-form.component.html',
  styleUrls: ['./marital-form.component.scss']
})
export class MaritalFormComponent implements OnInit {
  maritalForm: FormGroup;
  @Output() hasValidMarital = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();

  isLiveTogetherTrue: boolean = false;
  isLiveTogetherFalse: boolean = false;
  isCurrentlyMarriedTrue: boolean = false;
  isCurrentlyMarriedFalse: boolean = false;

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.maritalForm = this._formBuilder.group({
      maritalDate: [null, [dateValidator]],
      separatedDate: [null, [dateValidator]],
      isLiveTogether: [null],
      livingTogetherDate: [null, [dateValidator]],
      stopLivingTogetherDate: [null, [dateValidator]],
      isCurrentlyMarried: [null],
    });

    this.hasValidMarital.emit(this.maritalForm.valid);
    this.maritalForm.statusChanges.subscribe((res) => {
      this.hasValidMarital.emit(this.maritalForm.valid);
    });
    this.maritalForm.valueChanges.subscribe(res => {
      this.data.emit(res);
    });

    this.maritalForm.get('isLiveTogether').valueChanges.subscribe((value) => {
      this.toggleLiveTogetherDates(value);
    });
  }

  private toggleLiveTogetherDates(isLiveTogether: string): void {
    const livingTogetherDateControl: AbstractControl = this.maritalForm.get('livingTogetherDate');
    const stopLivingTogetherDateControl: AbstractControl = this.maritalForm.get('stopLivingTogetherDate');
    const maritalDateControl: AbstractControl = this.maritalForm.get('maritalDate');
    const separatedDateControl: AbstractControl = this.maritalForm.get('separatedDate');

    if (isLiveTogether === 'true') {
      livingTogetherDateControl.enable();
      livingTogetherDateControl.setValidators([Validators.required, dateValidator]);
      stopLivingTogetherDateControl.enable();
      stopLivingTogetherDateControl.setValidators([dateValidator]);

      maritalDateControl.disable();
      maritalDateControl.reset();
      separatedDateControl.disable();
      separatedDateControl.reset();
    } else if (isLiveTogether === 'false') {
      maritalDateControl.enable();
      separatedDateControl.enable();

      livingTogetherDateControl.disable();
      livingTogetherDateControl.reset();
      stopLivingTogetherDateControl.disable();
      stopLivingTogetherDateControl.reset();
    } else {
      maritalDateControl.enable();
      separatedDateControl.enable();
      livingTogetherDateControl.enable();
      livingTogetherDateControl.setValidators([dateValidator]);
      stopLivingTogetherDateControl.enable();
      stopLivingTogetherDateControl.setValidators([dateValidator]);
    }

    livingTogetherDateControl.updateValueAndValidity();
    stopLivingTogetherDateControl.updateValueAndValidity();
    maritalDateControl.updateValueAndValidity();
    separatedDateControl.updateValueAndValidity();
  }

  onCheckboxChange(controlName: string, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const fieldName = controlName.replace(/True|False/gi, '').trim();

    if (controlName.includes('True') && inputElement.checked) {
      this[`${fieldName}True`] = true;
      this[`${fieldName}False`] = false;
      this.maritalForm.patchValue({ [fieldName]: 'true' });
    } else if (controlName.includes('False') && inputElement.checked) {
      this[`${fieldName}True`] = false;
      this[`${fieldName}False`] = true;
      this.maritalForm.patchValue({ [fieldName]: 'false' });
    }
    else {
      this[`${fieldName}True`] = false;
      this[`${fieldName}False`] = false;
      this.maritalForm.patchValue({ [fieldName]: null });
    }
  }
}
